export default __webpack_public_path__ + "static/media/compose.1e8ab548.svg";